import { DownloadAppBannerModule } from './../download-app-banner/download-app-banner.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { CountoModule } from 'angular2-counto';
import { SharedModule } from '../../shared/shared.module';

import {
  AboutComponent,
  SupporterComponent,
  CommentComponent,
  FrTabsComponent,
  TeamComponent
} from './components/index';
/**UI Components */
import {
  AmountCardComponent,
  TopListComponent,
  RewardComponent,
  FbShareCardComponent
} from './ui-components/index';
import { DocSlidesModule } from '../doc-slides/doc-slides.module';
import { ButtonModule } from '../button/button.module';
import { CampaignerInfoModule } from '../campaigner-info/campaigner-info.module';
import { ChatWithUsModule } from '../chat-with-us/chat-with-us.module';
import { CommentCardModule } from '../comment-card/comment-card.module';
import { CommonHeaderModule } from '../common-header/common-header.module';
import { ContactDialogModule } from '../contact-dialog/contact-dialog.module';
import { DocumentModule } from '../document/document.module';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { DonationMethodsModule } from '../donation-methods/donation-methods.module';
import { DonorModule } from '../donor/donor.module';
import { EndFundraiserBannerModule } from '../end-fundraiser-banner/end-fundraiser-banner.module';
import { FbShareModule } from '../fb-share/fb-share.module';
import { FooterModule } from '../footer/footer.module';
import { FrCardModule } from '../fr-card/fr-card.module';
import { FrHeaderModule } from '../fr-header/fr-header.module';
import { ImgSliderModule } from '../img-slider/img-slider.module';
import { InnerTemplaterModule } from '../inner-templater/inner-templater.module';
import { InputModule } from '../input/input.module';
import { MatchingDonationCardModule } from '../matching-donation-card/matching-donation-card.module';
import { PaymentModule } from '../payment/payment.module';
import { PlaceholderLoaderModule } from '../placeholder-loader/placeholder-loader.module';
import { PreApproveBannerModule } from '../pre-approve-banner/pre-approve-banner.module';
import { ProgressBarModule } from '../progress-bar/progress-bar.module';
import { ReferFriendModule } from '../refer-friend/refer-friend.module';
import { SimilarFundraiserModule } from '../similar-fundraiser/similar-fundraiser.module';
import { SocialShareBtnModule } from '../social-share-btn/social-share-btn.module';
import { SocialShareModule } from '../social-share/social-share.module';
import { SupportCardModule } from '../support-card/support-card.module';
import { SupportingFrModule } from '../supporting-fr/supporting-fr.module';
import { ThankyouBannerModule } from '../thankyou-banner/thankyou-banner.module';
import { TickrModule } from '../tickr/tickr.module';
import { UpdateModule } from '../update/update.module';
import { ViewSupportersModule } from '../view-supporters/view-supporters.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { WidgetModule } from '../widget/widget.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MultiPatientNoteComponent } from '../multi-patient-note/multi-patient-note.component';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { SupportersComponent } from '../supporters/supporters.component';

const allComponents = [AboutComponent, SupporterComponent, CommentComponent,
  FrTabsComponent, TeamComponent, AmountCardComponent, TopListComponent,
  RewardComponent, FbShareCardComponent];

const AppCommonModules = [
  InputModule, CommentCardModule, DonateNowModule, DonorModule,
  FbShareModule, FrCardModule, FrHeaderModule,
  ProgressBarModule, UpdateModule, ButtonModule, WhatsappShareModule,
  PlaceholderLoaderModule, FooterModule, InnerTemplaterModule,
  DocumentModule, DonationMethodsModule, SupportCardModule, ViewSupportersModule,
  ImgSliderModule, ContactDialogModule, CommonHeaderModule, EndFundraiserBannerModule,
  ThankyouBannerModule, SocialShareBtnModule, SocialShareModule, PaymentModule, WidgetModule,
  ChatWithUsModule, SupportingFrModule, SimilarFundraiserModule, MatchingDonationCardModule, TickrModule,
  PreApproveBannerModule, CampaignerInfoModule, ReferFriendModule,
  DownloadAppBannerModule, MatTooltipModule
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTabsModule,
    SharedModule,
    SwiperModule,
    CountoModule,
    DocSlidesModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatRippleModule,
    ...AppCommonModules,
    ModuleLoaderModule,
    ComponentLoader,
    MultiPatientNoteComponent,
    SupportersComponent
  ],
  declarations: [
    ...allComponents
  ],
  exports: [
    ...allComponents
  ]
})
export class CommonFundraiserModule { }
